import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { Form } from 'src/app/shared/models/application/form';
import { FormType } from 'src/app/shared/models/application/formType';
import { FormService } from 'src/app/shared/services/form.service';
import { WidgetsService } from 'src/app/shared/services/widgets.service';
import { WidgetInstanceModel } from '../../shared/models/widget.model';
import { LatestFormSubmissionRow } from './latest-form-submission-row.model';
import { LatestFormSubmissionsService } from './latest-form-submissions.service';

@Component({
  selector: 'app-latest-form-submissions',
  templateUrl: './latest-form-submissions.component.html',
  styleUrls: ['./latest-form-submissions.component.scss'],
  standalone: false,
  providers: [LatestFormSubmissionsService]
})
export class LatestFormSubmissionsComponent implements OnInit, OnDestroy {
  @Input() widgetInfo: WidgetInstanceModel;

  subscriptions: Subscription[] = [];
  odataResult: LatestFormSubmissionRow[] = [];
  loaded = false;
  private _selectedFormId: string;
  private _forms: Form[] = [];
  itemPickerValues: ItemPickerModel[] = [];

  constructor(
    private latestFormSubmissionsService: LatestFormSubmissionsService,
    private formService: FormService,
    private widgetsService: WidgetsService
  ) {}

  ngOnInit(): void {
    this._selectedFormId = this.widgetInfo?.settings?.selectedViewId;
    this.latestFormSubmissionsService.getLatestFormSubmissions(this._selectedFormId);
    this.subscriptions.push(
      this.formService
        .getAll()
        .pipe(
          map((forms) => forms.filter((f) => f.formType == FormType.Application && !f.hasExpired))
        )
        .subscribe((forms) => {
          this._forms = forms;
          this.itemPickerValues = [new ItemPickerModel(null, null, 'All Forms')].concat(
            forms.map((x) => new ItemPickerModel(x.id, null, x.title))
          );
          if (this._selectedFormId && !forms.some((x) => x.id == this._selectedFormId)) {
            this.selectForm(null);
          }
        }),
      this.latestFormSubmissionsService.latestFormSubmissions.subscribe((result) => {
        if (result) {
          this.odataResult = result;
          this.loaded = true;
        }
      })
    );
  }

  get selectedItemPickerValue(): ItemPickerModel {
    return (
      this.itemPickerValues.find((x) => x.id == this._selectedFormId) ?? this.itemPickerValues[0]
    );
  }

  itemPickerSelect(model: ItemPickerModel) {
    this.selectForm(this._forms.find((x) => x.id == model.id)?.id);
  }

  private selectForm(formId: string) {
    this._selectedFormId = formId;
    this.loaded = false;
    this.latestFormSubmissionsService.getLatestFormSubmissions(this._selectedFormId);
    this.widgetInfo.settings = {
      ...this.widgetInfo.settings,
      selectedViewId: this._selectedFormId
    };
    this.widgetsService.updateInstanceSettings(this.widgetInfo);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
